import executeQuery from "#lib/db"
import { log } from "#debug"

import type { Recipe } from "#types"
import { RecipeTime } from "#types"

export const getTime = async ({ id }: { id: string }): Promise<Recipe> => {
	const list = await executeQuery({
		query: `
			select
				timePrep,
				timeCook,
				timeReady
            from
                recipes
            where
                recipeID=${id}`,
	})

	return list.length > 0 ? list[0] : {}
}

export const putTime = async (body: RecipeTime) => {
	const query = `
		update
			recipes
		set
			timePrep=${body.timePrep},
			timeCook=${body.timeCook},
			timeReady=${body.timeReady}
		where
			recipeID=${body.recipeID}`

	log(query)

	const results = await executeQuery({ query })

	return results
}
